import { GetMultiFieldSchemaResponseInterface, ListFieldGroupsResponseInterface, ListFieldSchemaResponseInterface } from '@vendasta/crm';

// TODO(KAT-1479): remove once `listFieldSchema` and `listFieldGroups` accept
// `crmObjectType: 'PotentialContact'` directly. Today the backend exposes
// PotentialContact records using Contact's schema with this literal suffix
// appended to each field id, so we look up Contact and post-process.
export const POTENTIAL_CONTACT_FIELD_SUFFIX = '-potential-contact';

export function appendPotentialContactSuffix(fieldId: string): string {
  if (!fieldId || fieldId.endsWith(POTENTIAL_CONTACT_FIELD_SUFFIX)) {
    return fieldId;
  }
  return `${fieldId}${POTENTIAL_CONTACT_FIELD_SUFFIX}`;
}

export function stripPotentialContactSuffix(fieldId: string): string {
  return fieldId.endsWith(POTENTIAL_CONTACT_FIELD_SUFFIX)
    ? fieldId.slice(0, -POTENTIAL_CONTACT_FIELD_SUFFIX.length)
    : fieldId;
}

export function suffixPotentialContactFieldIds(
  resp: ListFieldSchemaResponseInterface,
): ListFieldSchemaResponseInterface {
  return {
    ...resp,
    fieldSchemas: (resp.fieldSchemas ?? []).map((schema) => ({
      ...schema,
      fieldId: schema.fieldId ? appendPotentialContactSuffix(schema.fieldId) : schema.fieldId,
    })),
  };
}

export function suffixPotentialContactMultiFieldIds(
  resp: GetMultiFieldSchemaResponseInterface,
): GetMultiFieldSchemaResponseInterface {
  return {
    ...resp,
    fieldSchemas: (resp.fieldSchemas ?? []).map((schema) => ({
      ...schema,
      fieldId: schema.fieldId ? appendPotentialContactSuffix(schema.fieldId) : schema.fieldId,
    })),
  };
}

export function suffixPotentialContactFieldGroupIds(
  resp: ListFieldGroupsResponseInterface,
): ListFieldGroupsResponseInterface {
  return {
    ...resp,
    fieldGroups: (resp.fieldGroups ?? []).map((group) => ({
      ...group,
      fieldIds: (group.fieldIds ?? []).map((id) => (id ? appendPotentialContactSuffix(id) : id)),
    })),
  };
}
